import { render } from "./EmptyPage.vue?vue&type=template&id=afd1cbb8&ts=true"
import script from "./EmptyPage.vue?vue&type=script&lang=ts"
export * from "./EmptyPage.vue?vue&type=script&lang=ts"

import "./EmptyPage.vue?vue&type=style&index=0&id=afd1cbb8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__